export const ERROR_LOG_TYPES = [
  'errorModal',
  'uncaughtError',
  'unhandledRejection',
  'renderCrash',
  'manualReport'
] as const;

export const ERROR_LOG_MAX_PAGE_LENGTH = 150;
export const ERROR_LOG_MAX_URL_LENGTH = 2048;
export const ERROR_LOG_MAX_TEXT_LENGTH = 20_000;
export const ERROR_LOG_MAX_USER_AGENT_LENGTH = 512;
export const ERROR_LOG_MAX_BLOB_BYTES = 8 * 1024 * 1024;
export const ERROR_LOG_MAX_SCREENSHOT_CHARS = 3 * 1024 * 1024;
export const ERROR_LOG_SCREENSHOT_MAX_WIDTH = 1440;
export const ERROR_LOG_SCREENSHOT_TIMEOUT_MS = 4000;
export const ERROR_LOG_SCREENSHOT_QUALITIES = [0.65, 0.45, 0.3] as const;
export const ERROR_LOG_SCREENSHOT_IGNORE_ATTR = 'data-error-log-ignore';

export const ERROR_LOG_TYPE_LABELS: Record<
  (typeof ERROR_LOG_TYPES)[number],
  string
> = {
  errorModal: 'Error Modal',
  uncaughtError: 'Uncaught Error',
  unhandledRejection: 'Unhandled Rejection',
  renderCrash: 'Render Crash',
  manualReport: 'Manual Report'
};

export const REPRODUCE_ERROR_LOG_PARAM = 'reproduceErrorLogId';

export const CONSOLE_BUFFER_SIZE = 200;
export const CONSOLE_ENTRY_MAX_LENGTH = 2000;
export const INTERACTION_BUFFER_SIZE = 20;
export const ACTION_BREADCRUMB_BUFFER_SIZE = 30;

export const SNAPSHOT_SCHEMA_VERSION = 1;
export const MAX_SNAPSHOT_BYTES = ERROR_LOG_MAX_BLOB_BYTES;
export const ERROR_LOG_SLICE_PREVIEW_MAX_CHARS = 64 * 1024;

export const HYDRATABLE_SLICES = [
  'project',
  'structure',
  'configurations',
  'systems',
  'ui',
  'ai',
  'chatbot',
  'ductedCompatibility'
] as const;

export const SNAPSHOT_DROP_ORDER = [
  'systems',
  'ductedCompatibility',
  'chatbot',
  'ai'
] as const;

export const ERROR_LOG_DEDUPE_WINDOW_MS = 10_000;
export const ERROR_LOG_MAX_REPORTS_PER_MINUTE = 20;
export const ERROR_LOGS_LIST_LIMIT = 1000;

export const IGNORED_GLOBAL_ERROR_PATTERNS = [/ResizeObserver loop/i];
